import getWishlists from "./getWishlists";
import CacheableResult from "../../common/utils/CacheableResult";

const cachableWishlists = new CacheableResult(() => getWishlists(), 4000);

export default cachableWishlists.read.bind(cachableWishlists);
